import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["id", "label", "children", "className", "buttonClassName", "iconClassName", "contentClassName", "contentWrapperClassName", "variant", "size", "showIcon", "closeOnClickOutside", "disabled", "expandOnDesktop", "expandOnMobile", "expandOnTablet", "dataContentName", "dataContentPiece", "closeButtonLabel", "selectedValuesLabel"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsxs as p, jsx as o } from "react/jsx-runtime";
import R, { useRef as W, useState as z, useCallback as j, useEffect as H } from "react";
import { c as e } from "../clsx-OuTLNxxd.js";
import { Icon as L } from "../Icon/Icon.js";
import { Button as B } from "../Button/Button.js";
import { s as T } from "../checks-C6AyTTQ0.js";
const Z = "DropDown-module_labels-container__CRwlY",
  y = "DropDown-module_label__iq-ZU",
  J = "DropDown-module_with-selection__giHg4",
  K = "DropDown-module_values-label__4hmMt",
  P = "DropDown-module_button__2jHXI",
  U = "DropDown-module_button-with-selection__dBSd5",
  X = "DropDown-module_icon__002vj",
  Y = "DropDown-module_content__tGLTo",
  q = "DropDown-module_drop-down__9T4Db",
  F = "DropDown-module_mobile-expand-open__ru7pi",
  G = "DropDown-module_content-wrapper__4YRz2",
  $ = "DropDown-module_tablet-expand-open__SlJ5c",
  Q = "DropDown-module_desktop-expand-open__ZwpxR",
  M = "DropDown-module_mobile-expand-inline__arssO",
  V = "DropDown-module_drop-down-open__oi5Nt",
  nn = "DropDown-module_close__VWOC4",
  on = "DropDown-module_tablet-expand-inline__RnpKL",
  en = "DropDown-module_desktop-expand-inline__8lcK7",
  tn = "DropDown-module_mobile-expand-absolute__wS-HS",
  ln = "DropDown-module_tablet-expand-absolute__63F4j",
  an = "DropDown-module_desktop-expand-absolute__UoLAr",
  pn = "DropDown-module_drop-down-default__ZzeRX",
  dn = "DropDown-module_drop-down-transparent__hDW4v",
  rn = "DropDown-module_drop-down-size-big__Jus9H",
  sn = "DropDown-module_drop-down-dark__t4S9T",
  n = {
    labelsContainer: Z,
    label: y,
    withSelection: J,
    valuesLabel: K,
    button: P,
    buttonWithSelection: U,
    icon: X,
    content: Y,
    dropDown: q,
    mobileExpandOpen: F,
    contentWrapper: G,
    tabletExpandOpen: $,
    desktopExpandOpen: Q,
    mobileExpandInline: M,
    dropDownOpen: V,
    close: nn,
    tabletExpandInline: on,
    desktopExpandInline: en,
    mobileExpandAbsolute: tn,
    tabletExpandAbsolute: ln,
    desktopExpandAbsolute: an,
    dropDownDefault: pn,
    dropDownTransparent: dn,
    dropDownSizeBig: rn,
    dropDownDark: sn
  },
  wn = _ref => {
    let {
        id: x,
        label: _,
        children: E,
        className: f,
        buttonClassName: h,
        iconClassName: k,
        contentClassName: S,
        contentWrapperClassName: I,
        variant: t = "default",
        size: v = "default",
        showIcon: g = !0,
        closeOnClickOutside: m = !1,
        disabled: A = !1,
        expandOnDesktop: d = "absolute",
        expandOnMobile: r = "inline",
        expandOnTablet: s = "inline",
        dataContentName: i,
        dataContentPiece: O,
        closeButtonLabel: b,
        selectedValuesLabel: l
      } = _ref,
      C = _objectWithoutProperties(_ref, _excluded);
    const c = typeof l == "string" ? T(l) : R.Children.count(l) > 0,
      u = W(null),
      [a, D] = z(!1),
      w = j(N => {
        m && u.current && !u.current.contains(N.target) && D(!1);
      }, [m]);
    return H(() => (document.addEventListener("click", w), () => document.removeEventListener("click", w)), []), /* @__PURE__ */p("div", {
      "data-content-name": i,
      ref: u,
      className: e(n.dropDown, f, {
        [n.dropDownDefault]: t == "default",
        [n.dropDownTransparent]: t == "transparent",
        [n.dropDownDark]: t == "dark",
        [n.dropDownSizeBig]: v == "big",
        [n.mobileExpandInline]: r == "inline",
        [n.mobileExpandAbsolute]: r == "absolute",
        [n.mobileExpandOpen]: r == "open",
        [n.tabletExpandInline]: s == "inline",
        [n.tabletExpandAbsolute]: s == "absolute",
        [n.tabletExpandOpen]: s == "open",
        [n.desktopExpandInline]: d == "inline",
        [n.desktopExpandAbsolute]: d == "absolute",
        [n.desktopExpandOpen]: d == "open",
        [n.dropDownOpen]: a
      }),
      children: [/* @__PURE__ */p("button", _objectSpread(_objectSpread({}, C), {}, {
        id: x,
        className: e(n.button, h, {
          [n.buttonWithSelection]: c
        }),
        onClick: () => D(!a),
        "aria-label": _ === null || _ === void 0 ? void 0 : _.toString(),
        "data-content-piece": O,
        disabled: A,
        "aria-expanded": a,
        children: [/* @__PURE__ */p("span", {
          className: e(n.labelsContainer, {
            [n.withSelection]: c
          }),
          children: [/* @__PURE__ */o("span", {
            className: n.label,
            children: _
          }), c && /* @__PURE__ */o("span", {
            className: n.valuesLabel,
            children: l
          })]
        }), g && /* @__PURE__ */o(L, {
          name: "chevron-down",
          size: "1.5x",
          padding: !1,
          className: e(k, n.icon),
          ariaHidden: !0
        })]
      })), /* @__PURE__ */p("div", {
        tabIndex: -1,
        className: e(n.contentWrapper, I),
        "aria-hidden": !a,
        children: [/* @__PURE__ */o("div", {
          className: e(n.content, S),
          "data-content-name": i ? "".concat(i, "-content") : void 0,
          tabIndex: -1,
          children: E
        }), b && /* @__PURE__ */o("div", {
          className: n.close,
          children: /* @__PURE__ */o(B, {
            variant: "text",
            renderAs: "button",
            onClick: () => D(!1),
            dataContentPiece: "close",
            inverted: t == "dark",
            children: b
          })
        })]
      })]
    });
  };
export { wn as DropDown };